<template>
  <div style="font-size: 0.24rem; padding-top: 1rem;">
    <div class="video-description">选择开票应税地，点击区域查看操作视频</div>
    <div class="video-container">
      <div class="video-item" @click="handlePlayVideo(2)">
        <div class="desc-top">
          <p>开票应税地</p>
          <p>北京、山东、山西、湖北、海南、宁夏等</p>
        </div>
        <van-image class="video-sign" width="80" height="80" :src="inputImg" />
      </div>
      <div class="video-item face" @click="handlePlayVideo(1)">
        <div class="desc-top">
          <p>开票应税地</p>
          <p>上海、深圳、广东、天津、重庆、浙江、江苏、四川、安徽、湖南、河南、河北、陕西、辽宁、黑龙江、内蒙古、新疆等</p>
        </div>
        <van-image class="video-sign" width="80" height="80" :src="scanImg" />
      </div>
    </div>
    <div class="back-button">
      <van-button class="full-button" block round @click="handleBack" color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)">返回</van-button>
    </div>
    <van-popup v-model="visible" :close-on-click-overlay="false" closeable @closed="videoClosed" style="background: transparent">
      <video
        ref="video"
        class="videofull"
        :src="videoSrc"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-player-orientation="landscape"
        webkit-playsinline="true"
        controls="controls"
        fullscreenToggle="true"
      ></video>
    </van-popup>
  </div>

</template>

<script>
  import { Popup, Image as VanImage } from 'vant';
  export default {
    name: "HelpVideo",
    data() {
      return {
        visible: false,
        scanImg: require(`@/assets/img/mobile/scan.png`),
        inputImg: require(`@/assets/img/mobile/input.png`),
        videoSrc: ''
      }
    },
    methods: {
      handlePlayVideo(type) {
        this.videoSrc = type == 1 ? '/video/help-face.mp4' : '/video/help.mp4'
        this.visible = true
      },
      videoClosed() {
        const video = this.$refs.video;
        if (video && !video.paused) {
          video.pause();
        }
      },
      handleBack() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .videofull {
    width: calc(100vw - 0.6rem);
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
  }
  
  .video-container {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .video-item {
      width: 3.2rem;
      height: 3.3rem;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, .12);
      -webkit-border-radius: 0.1rem;
      -moz-border-radius: 0.1rem;
      border-radius: 0.1rem;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      .desc-top {
        padding: 0.28rem;
        color: #666;
        background: linear-gradient(to bottom, #ebedee, #ffffff);
        position: relative;
        p:first-child {
          font-weight: bold;
          margin-bottom: 0.1rem;
        }
      }
      &.face{
        .desc-top {
          background: linear-gradient(to bottom, #e7f0fd, #ffffff)
        }
      }
      .video-sign {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, 0);
        -moz-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        -o-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        opacity: 0.2;
      }
    }
  }
  .video-description {
    padding: 0.3rem;
    margin-bottom: 0.5rem;
    font-size: 0.32rem;
    text-align: center;
    color: #666;
  }
</style>
